import React, { useEffect } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import "./History.css";
interface Props {
  historial: any[];
  show: boolean;
  onHide: () => void;
  setErrorQuantities: (errorQuantities: number) => void;
}

const LocalHistoryModal = ({
  historial,
  show,
  onHide,
  setErrorQuantities,
}: Props) => {
  useEffect(() => {
    setErrorQuantities(0);
  }, []);

  const reversedHistorial = [...historial].reverse();

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Historial de Transacciones</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="fullhistorial">
          {reversedHistorial?.map((record) => (
            <Row
              className={`d-flex justify-content-center ${record.success ? "text-success" : "text-danger"}`}
            >
              <span
                title={record.info}
                className="text-center"
                style={{ fontSize: "12px" }}
              >
                <span className="mx-1">[{record.hour}]</span>

                {(record.type !== 'promo' || !record.success) && <span>
                  {record.type === "bajar" ? "Bajar" : "Cargar"}{" "}
                  {record.quantity} fichas a {record.user}:
                  {record.success ? " hecho" : " fallo"}
                </span>}

                {record.type === 'promo' && record.success && <span>
                  {record.info.message}:{record.success ? " hecho" : " fallo"}
                </span>}

              </span>
            </Row>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocalHistoryModal;
